import React, { useState } from 'react';
import {
  Button,
  ButtonGroup,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Typography,
} from '@one-thd/sui-atomic-components';
import PropTypes from 'prop-types'; // Import PropTypes

export const ConfirmationModal = ({
  isOpen, onClose, onConfirm, itemName, message, headerTitle, confirmButtonName, switchButtonPosition
}) => {
  const firstButton = switchButtonPosition ? 'secondary' : 'primary';
  const secondButton = switchButtonPosition ? 'primary' : 'secondary';
  const firstButtonName = switchButtonPosition ? 'Cancel' : confirmButtonName;
  const secondButtonName = switchButtonPosition ? confirmButtonName : 'Cancel';
  const firstButtonClick = switchButtonPosition ? onClose : onConfirm;
  const secondButtonClick = switchButtonPosition ? onConfirm : onClose;
  return (
    <Modal open={isOpen} onClose={onClose}>
      <ModalHeader onClose={onClose}>{headerTitle}</ModalHeader>
      <ModalBody>
        <Typography variant="body-base">
          { message}
        </Typography>
        {itemName === 'Toekicks' && ( // Conditionally render the image
          <div className="sui-mt-4 sui-text-center"> {/* Added some margin top and centering */}
            <img
              src="https://blinds.homedepot.com/product-images/0b543cb2-61d7-ef11-848c-0afffee37a07.png?
              width=250&height=300&quality=70&mode=crop"
              width="100%"
              height="auto"
              alt="Accessory"
            />

          </div>
        )}
      </ModalBody>
      <ModalFooter position="end">
        <ButtonGroup>
          <Button variant={firstButton} onClick={firstButtonClick}>
            {firstButtonName}
          </Button>
          <Button variant={secondButton} onClick={secondButtonClick}>
            {secondButtonName}
          </Button>
        </ButtonGroup>
      </ModalFooter>
    </Modal>
  );
};

ConfirmationModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  itemName: PropTypes.string,
  message: PropTypes.string,
  headerTitle: PropTypes.string,
  confirmButtonName: PropTypes.func.isRequired,
  switchButtonPosition: PropTypes.bool,
};

ConfirmationModal.defaultProps = {
  itemName: '',
  message: '',
  headerTitle: '',
  switchButtonPosition: false,
};
